export default class CommentType {
    static get PRODUCT() {
        return 1
    }

    static get PAGE() {
        return 2
    }

    static get PHARMACY_FROM_WEB() {
        return 3
    }

    static get PHARMACY_RESERVATION() {
        return 4
    }

    static get PHARMACY_OFFLINE_PURCHASE() {
        return 5
    }

    static get PHARMACY_ERECEPT_RESERVATION() {
        return 6
    }

    static get PILULKA_SERVICE_RATING() {
        return 7
    }

    static get CUSTOMER_SUPPORT_PHONE_CALL() {
        return 8
    }

    static get COMPLAINT() {
        return 9
    }

    static get ZENDESK_TICKET() {
        return 10
    }

    static get PILULKA_CAR() {
        return 11
    }

    static get PHARMACY_PILULKA_POINT() {
        return 12
    }

    static get SERVICE_OFFICE() {
        return 13
    }
}
